import { navigation, product } from '../lib/site'
import { Reveal } from './Reveal'
import { BrandLockup } from './BrandMark'

const sections = [
  {
    title: 'Product',
    links: navigation.map(item => ({ label: item.label, href: item.href })),
  },
  {
    title: 'Explore',
    links: [
      { label: 'How search works', href: '/#capabilities' },
      { label: 'Information governance', href: '/#governance' },
      { label: 'Deployment modes', href: '/#deployment' },
      { label: 'Engineering budgets', href: '/#budgets' },
    ],
  },
  {
    title: 'Deployment',
    links: [
      { label: 'Standalone local', href: '/#deployment' },
      { label: 'Managed hybrid', href: '/#deployment' },
      { label: 'Trust boundaries', href: '/security' },
      { label: 'Plan a rollout', href: '/#contact' },
    ],
  },
]

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="shell">
        <div className="footer-grid">
          <Reveal className="footer-brand" variant="up">
            <a className="brand" href="/">
              <BrandLockup height={54} />
            </a>
            <p className="body">{product.tagline}</p>
            <dl className="footer-spec mono">
              <div>
                <dt>Platform</dt>
                <dd>{product.platform}</dd>
              </div>
              <div>
                <dt>Content</dt>
                <dd>{product.languages}</dd>
              </div>
              <div>
                <dt>Delivery</dt>
                <dd>Signed MSI · Desktop + Agent</dd>
              </div>
            </dl>
          </Reveal>

          {sections.map((section, index) => (
            <Reveal key={section.title} className="footer-column" variant="up" index={index + 1}>
              <h3 className="mono">{section.title}</h3>
              <ul>
                {section.links.map(link => (
                  <li key={link.label + link.href}>
                    <a href={link.href}>{link.label}</a>
                  </li>
                ))}
              </ul>
            </Reveal>
          ))}
        </div>

        <div className="footer-wordmark" aria-hidden="true">
          <Reveal variant="mask" as="span">
            libris
          </Reveal>
        </div>

        <div className="footer-base mono">
          <span>
            © {product.year} Libris. Documents stay where they are.
          </span>
          <span>Local-first · Permission-aware · Auditable</span>
        </div>
      </div>
    </footer>
  )
}
